import Footer from "../Globals/Footer";
import HeaderNavbar from "../Globals/HeaderNavbar";

const Main = (props) => {
    return (
        <>
            <HeaderNavbar />
            {props.children}
            <Footer />
        </>
    );
};

export default Main;
